import React, { useRef, useState } from 'react';
import emailjs from '@emailjs/browser';
import ReCAPTCHA from 'react-google-recaptcha';
import toast, { Toaster } from 'react-hot-toast';
import { 
  Grid,
  GridRow,
  GridColumn, 
  Header, 
} from 'semantic-ui-react';

const buttonFormStyle = {
  backgroundColor: 'transparent',
  border: "solid 0.1em #FFFFFF",
  borderColor: '#FFFFFF',
  borderRadius: '3em',
  borderWidth: '0.1em',
  borderStyle: 'solid',
  color: '#FFFFFF',
  paddingTop: '0.8em',
  paddingBottom: '0.8em',
  paddingLeft: '3em',
  paddingRight: '3em',
  fontSize: "1em",
  cursor: 'pointer',
  padding: "0.6em 3em 0.6em 3em",
  transition: "padding 0.5s ease",
  fontFamily: "'Lato', sans-serif",
  fontWeight: "400",
};

const buttonFormStyleHover = {
  ...buttonFormStyle,
  padding: "0.6em 4em 0.6em 4em",
  transition: "padding 0.5s ease",
};

const inputStyle = {
  background: 'transparent',
  borderBottom: "solid 0.1em #FFFFFF",
  borderTop: "solid 0em #FFFFFF",
  borderLeft: "solid 0em #FFFFFF",
  borderRight: "solid 0em #FFFFFF",
  borderRadius: '0em',
  color: '#FFFFFF',
  lineHeight: '35px',
  marginBottom: '25px',
  paddingLeft: '1em',
  width: '100%',
  fontFamily: "'Lato', sans-serif",
  fontWeight: "400",
  fontSize: "clamp(1.1em, 1vw, 1.4em)",
}

const textAreaStyle = {
  ...inputStyle, 
  height: '150px',  
}

const h1Style = {
  fontFamily: "'B612', sans-serif",
  fontWeight: "400",
  color: "#FFFFFF",
  fontSize: "clamp(3em, 4vw, 4em)",
}

const labelPStyle = {
  fontFamily: "'Lato', sans-serif",
  fontWeight: "400",
  color: "#8C8C8C",
  fontSize: "clamp(1.1em, 1vw, 1.4em)",
  lineHeight: "clamp(1.3em, 1.3vw, 1.5em)",
  margin: '0em 0em 1em 0em',
}

const labelStyle = {
display: 'flex', 
alignItems: 'center', 
cursor: 'pointer', 
width: '100%',
}

const pStyle = {
  fontFamily: "'Lato', sans-serif",
  fontWeight: "700",
  color: "#FFFFFF",
  fontSize: "clamp(1.1em, 1vw, 1.4em)",
  lineHeight: "clamp(1.3em, 1.3vw, 1.5em)",
  margin: '0em 0em 1em 0em',
  textAlign: "left",
}

const checkboxDivStyle = {
  margin: "0em 0em 1em 0em",
  width: '100%', // Ensures the flex container takes full width
  minWidth: '90%', // Adjust as needed for your layout
  borderBottom: "solid 0.1em #FFFFFF",
  borderTop: "solid 0em #FFFFFF",
  borderLeft: "solid 0em #FFFFFF",
  borderRight: "solid 0em #FFFFFF",
  borderRadius: '0em',
}

const checkboxStyle = {
  display: 'inline-block',
  width: '20px',
  height: '20px',
  border: 'solid 0.1em #FFFFFF',
  borderRadius: '0em',
  marginRight: '1em',
  position: 'relative',
  transition: 'background 0.1s',
  background: 'transparent',
  cursor: 'pointer',
  margin: '0em 1em 1em 0em',
}

const checkboxTickStyle = {
  position: 'absolute',
  left: '0.45em',
  width: '0.4em',
  height: '1em',
  border: 'solid #FFFFFF',
  borderWidth: '0 0.15em 0.15em 0',
  transform: 'rotate(45deg)',
}

export const ContactForm = () => {
  const form = useRef();
  const [hoveredFormSubmit, setHoveredFormSubmit] = useState(false);
  const [recaptchaValue, setRecaptchaValue] = useState(null);
  const [requestSiteVisit, setRequestSiteVisit] = useState(false);
  const [radio, setRadio] = useState(false);
  const [onlineSearch, setOnlineSearch] = useState(false);
  const [wordOfMouth, setWordOfMouth] = useState(false);
  const [ute, setUte] = useState(false);
  const [other, setOther] = useState(false);

  const handleRecaptchaChange = (value) => {
    setRecaptchaValue(value);
  };

  const sendEmail = (e) => {
    e.preventDefault();
    if (recaptchaValue) {
      emailjs
        .sendForm('service_tjepx0w', 'template_x39zrzn', form.current, {
          publicKey: 'D4obohlGKanuQuTIi',
        })
        .then(
          () => {
            toast.success('Email sent successfully!');
            console.log('SUCCESS!');
          },
          (error) => {
            toast.error(`Email sending failed: ${error.text}`);
            console.log('FAILED...', error.text);
          },
        );
    } else {
      toast.error('Please complete the reCAPTCHA');
      console.log('Please complete the reCAPTCHA');
    }
  };

  const placeholderColor = '#8C8C8C';

  return (
    <div 
      style={{ 
        display: 'block', 
        textAlign: 'center',
        padding: '0em 0em 10em 0em', 
      }}>
      <Toaster/>
      <Grid>
        <GridRow columns={1} style={{padding: "10em 0em 2em 0em" }}>
          <GridColumn textAlign='center'>
            <Header
              as='h1'
              content='Receive a Free Quote'
              id="contact-form-header"
              style={h1Style}
            />
          </GridColumn>
        </GridRow>
      </Grid>

      <form
        id="contact-form"
        ref={form}
        onSubmit={sendEmail}
        style={{ 
          display: 'inline-block', 
          padding: '3em 5% 0em 5%',
        }}
      >
        <style>
          {`
            .input-placeholder::placeholder {
              color: ${placeholderColor};
            }
          `}
        </style>
        <input
          type="text"
          name="user_name"
          placeholder="Name"
          aria-label="Your name"
          className="input-placeholder"
          style={inputStyle}
        />
        <input
          type="email"
          name="user_email"
          placeholder="Email"
          aria-label="Your email address"
          className="input-placeholder"
          style={inputStyle}
        />

        <div style={checkboxDivStyle}>
          <input
            type="checkbox"
            name="request_site_visit"
            id="request_site_visit"
            checked={requestSiteVisit}
            onChange={() => setRequestSiteVisit(!requestSiteVisit)}
            style={{ display: 'none' }} // Hide default checkbox
          />
          <label htmlFor="request_site_visit" style={labelStyle}>
            <span style={checkboxStyle}>
              {requestSiteVisit && <span style={checkboxTickStyle} />}
            </span>
            <span style={labelPStyle}>Request a site visit</span>
          </label>
        </div>

        <div style={checkboxDivStyle}>
          <p style={pStyle}>How did you hear about us?</p>

          <input
            type="checkbox"
            name="radio"
            id="radio"
            checked={radio}
            onChange={() => setRadio(!radio)}
            style={{ display: 'none' }} // Hide default checkbox
          />
          <label htmlFor="radio" style={labelStyle}>
            <span style={checkboxStyle}>
              {radio && <span style={checkboxTickStyle} />}
            </span>
            <span style={labelPStyle}>Radio</span>
          </label>

          <input
            type="checkbox"
            name="online_search"
            id="online_search"
            checked={onlineSearch}
            onChange={() => setOnlineSearch(!onlineSearch)}
            style={{ display: 'none' }} // Hide default checkbox
          />
          <label htmlFor="online_search" style={labelStyle}>
            <span style={checkboxStyle}>
              {onlineSearch && <span style={checkboxTickStyle} />}
            </span>
            <span style={labelPStyle}>Online Search</span>
          </label>

          <input
            type="checkbox"
            name="word_of_mouth"
            id="word_of_mouth"
            checked={wordOfMouth}
            onChange={() => setWordOfMouth(!wordOfMouth)}
            style={{ display: 'none' }} // Hide default checkbox
          />
          <label htmlFor="word_of_mouth" style={labelStyle}>
            <span style={checkboxStyle}>
              {wordOfMouth && <span style={checkboxTickStyle} />}
            </span>
            <span style={labelPStyle}>Word of Mouth</span>
          </label>

          <input
            type="checkbox"
            name="ute"
            id="ute"
            checked={ute}
            onChange={() => setUte(!ute)}
            style={{ display: 'none' }} // Hide default checkbox
          />
          <label htmlFor="ute" style={labelStyle}>
            <span style={checkboxStyle}>
              {ute && <span style={checkboxTickStyle} />}
            </span>
            <span style={labelPStyle}>I saw your ute</span>
          </label>

          <input
            type="checkbox"
            name="other"
            id="other"
            checked={other}
            onChange={() => setOther(!other)}
            style={{ display: 'none' }} // Hide default checkbox
          />
          <label htmlFor="other" style={labelStyle}>
            <span style={checkboxStyle}>
              {other && <span style={checkboxTickStyle} />}
            </span>
            <span style={labelPStyle}>Other</span>
          </label>
        </div>

        <textarea
          name="message"
          placeholder="Tell us about your project"
          aria-label="Your message"
          className="input-placeholder"
          style={textAreaStyle}
        />
        <ReCAPTCHA
          sitekey="6LeWdPAqAAAAAHMt1zyrnm_LsRXX72JgC3XnOMzi"
          onChange={handleRecaptchaChange}
          style={{ marginBottom: '20px' }}
        />
        <input
          type="submit"
          value="Send"
          content="Send"
          onMouseEnter={() => setHoveredFormSubmit(true)}
          onMouseLeave={() => setHoveredFormSubmit(false)}
          style={hoveredFormSubmit ? buttonFormStyleHover : buttonFormStyle}
        />
      </form>
    </div>
  );
}; export default ContactForm;